export interface PredefinedInventoryItem {
  id: string;
  name: string;
  category: string;
  unit: string;
  suggested_minimum_quantity: number;
  suggested_cost?: number;
  description: string;
  recommended_reason?: string;
  isEssential?: boolean; // Itens fundamentais recomendados para qualquer loja
}

export const PREDEFINED_INVENTORY_ITEMS: PredefinedInventoryItem[] = [
  // ==========================================
  // 1. LANCHONETE & BEBIDAS (10 itens)
  // ==========================================
  {
    id: 'lanchonete-agua-mineral-500ml',
    name: 'Água Mineral sem Gás 500ml',
    category: 'Lanchonete & Bebidas',
    unit: 'un',
    suggested_minimum_quantity: 24,
    suggested_cost: 1.50,
    description: 'Garrafas individuais de água mineral para consumo de jogadores e balcão.',
    isEssential: true
  },
  {
    id: 'lanchonete-agua-mineral-gas-500ml',
    name: 'Água Mineral com Gás 500ml',
    category: 'Lanchonete & Bebidas',
    unit: 'un',
    suggested_minimum_quantity: 12,
    suggested_cost: 1.80,
    description: 'Garrafas individuais de água com gás para clientes e torneios.',
    isEssential: false
  },
  {
    id: 'lanchonete-refrigerante-coca-cola-350ml',
    name: 'Refrigerante Coca-Cola Lata 350ml',
    category: 'Lanchonete & Bebidas',
    unit: 'un',
    suggested_minimum_quantity: 24,
    suggested_cost: 3.20,
    description: 'Lata de refrigerante para frigobar ou lanchonete da loja.',
    isEssential: true
  },
  {
    id: 'lanchonete-refrigerante-guarana-350ml',
    name: 'Refrigerante Guaraná Antarctica Lata 350ml',
    category: 'Lanchonete & Bebidas',
    unit: 'un',
    suggested_minimum_quantity: 18,
    suggested_cost: 2.90,
    description: 'Lata de guaraná tradicional para lanchonete e eventos.',
    isEssential: false
  },
  {
    id: 'lanchonete-energetico-monster-473ml',
    name: 'Energético Monster Energy 473ml',
    category: 'Lanchonete & Bebidas',
    unit: 'un',
    suggested_minimum_quantity: 12,
    suggested_cost: 7.50,
    description: 'Lata de energético para eventos longos e torneios competitivos.',
    isEssential: true
  },
  {
    id: 'lanchonete-salgadinho-doritos-75g',
    name: 'Salgadinho Doritos 75g',
    category: 'Lanchonete & Bebidas',
    unit: 'un',
    suggested_minimum_quantity: 15,
    suggested_cost: 4.80,
    description: 'Snack crocante sabor queijo nacho para lanches rápidos.',
    isEssential: false
  },
  {
    id: 'lanchonete-salgadinho-ruffles-76g',
    name: 'Salgadinho Ruffles Tradicional 76g',
    category: 'Lanchonete & Bebidas',
    unit: 'un',
    suggested_minimum_quantity: 12,
    suggested_cost: 4.80,
    description: 'Batata frita ondulada salgada para vendas no balcão.',
    isEssential: false
  },
  {
    id: 'lanchonete-cafe-po-500g',
    name: 'Café Torrado e Moído Tradicional 500g',
    category: 'Lanchonete & Bebidas',
    unit: 'pct',
    suggested_minimum_quantity: 2,
    suggested_cost: 16.50,
    description: 'Café em pó para a cafeteira da loja, atendimento e equipe.',
    isEssential: true
  },
  {
    id: 'lanchonete-copo-descartavel-200ml',
    name: 'Copo Descartável Transparente 200ml (Pacote com 100)',
    category: 'Lanchonete & Bebidas',
    unit: 'pct',
    suggested_minimum_quantity: 5,
    suggested_cost: 4.50,
    description: 'Copos plásticos para bebedouro e consumo de refrigerantes.',
    isEssential: true
  },
  {
    id: 'lanchonete-copo-descartavel-cafe-50ml',
    name: 'Copo Descartável para Café 50ml (Pacote com 100)',
    category: 'Lanchonete & Bebidas',
    unit: 'pct',
    suggested_minimum_quantity: 3,
    suggested_cost: 3.20,
    description: 'Copinhos pequenos para cafezinho no balcão.',
    isEssential: false
  },

  // ==========================================
  // 2. LIMPEZA & MANUTENÇÃO (10 itens)
  // ==========================================
  {
    id: 'limpeza-alcool-70-liquido-1l',
    name: 'Álcool Líquido 70% 1 Litro',
    category: 'Limpeza & Manutenção',
    unit: 'l',
    suggested_minimum_quantity: 3,
    suggested_cost: 6.80,
    description: 'Desinfetante para mesas de jogo, balcão e superfícies.',
    isEssential: true
  },
  {
    id: 'limpeza-alcool-gel-70-pump-500ml',
    name: 'Álcool em Gel 70% com Pump 500ml',
    category: 'Limpeza & Manutenção',
    unit: 'un',
    suggested_minimum_quantity: 2,
    suggested_cost: 9.50,
    description: 'Frasco com dispenser para entrada da loja e área de torneios.',
    isEssential: true
  },
  {
    id: 'limpeza-papel-toalha-interfolha',
    name: 'Papel Toalha Interfolha 2 Dobras (Pacote com 1000 folhas)',
    category: 'Limpeza & Manutenção',
    unit: 'pct',
    suggested_minimum_quantity: 4,
    suggested_cost: 14.00,
    description: 'Papel toalha para banheiro e suporte da pia da loja.',
    isEssential: true
  },
  {
    id: 'limpeza-papel-higienico-folha-dupla',
    name: 'Papel Higiênico Folha Dupla (Fardo com 12 rolos)',
    category: 'Limpeza & Manutenção',
    unit: 'pct',
    suggested_minimum_quantity: 2,
    suggested_cost: 18.50,
    description: 'Papel higiênico para o banheiro de clientes e funcionários.',
    isEssential: true
  },
  {
    id: 'limpeza-detergente-neutro-500ml',
    name: 'Detergente Neutro Líquido 500ml',
    category: 'Limpeza & Manutenção',
    unit: 'un',
    suggested_minimum_quantity: 3,
    suggested_cost: 2.60,
    description: 'Detergente para higienização de xícaras, copos e pia da copa.',
    isEssential: false
  },
  {
    id: 'limpeza-desinfetante-multiuso-1l',
    name: 'Desinfetante Multiuso Floral 1 Litro',
    category: 'Limpeza & Manutenção',
    unit: 'l',
    suggested_minimum_quantity: 2,
    suggested_cost: 5.90,
    description: 'Limpeza de pisos e ambiente geral da loja.',
    isEssential: false
  },
  {
    id: 'limpeza-saco-lixo-reforcado-50l',
    name: 'Saco de Lixo Reforçado Preto 50L (Pacote com 30)',
    category: 'Limpeza & Manutenção',
    unit: 'pct',
    suggested_minimum_quantity: 3,
    suggested_cost: 12.00,
    description: 'Sacos resistentes para lixeiras das mesas de jogo e balcão.',
    isEssential: true
  },
  {
    id: 'limpeza-saco-lixo-reforcado-100l',
    name: 'Saco de Lixo Reforçado 100L (Pacote com 20)',
    category: 'Limpeza & Manutenção',
    unit: 'pct',
    suggested_minimum_quantity: 2,
    suggested_cost: 15.00,
    description: 'Sacos para descarte geral de caixas e embalagens ao fim do dia.',
    isEssential: false
  },
  {
    id: 'limpeza-pano-microfibra-premium',
    name: 'Pano de Microfibra Multiuso (Kit com 3 unidades)',
    category: 'Limpeza & Manutenção',
    unit: 'pct',
    suggested_minimum_quantity: 2,
    suggested_cost: 11.00,
    description: 'Panos macios que não soltam pelos, ideais para vitrines e balcão.',
    isEssential: false
  },
  {
    id: 'limpeza-pilha-aa-alcalina-pct4',
    name: 'Pilhas Alcalinas AA (Blister com 4 unidades)',
    category: 'Limpeza & Manutenção',
    unit: 'pct',
    suggested_minimum_quantity: 3,
    suggested_cost: 16.00,
    description: 'Pilhas para relógios de parede, timers e periféricos sem fio.',
    isEssential: false
  },

  // ==========================================
  // 3. EMBALAGENS & ENVIOS (11 itens)
  // ==========================================
  {
    id: 'envios-envelope-bolha-p-15x20',
    name: 'Envelope com Bolha Kraft P (15x20cm)',
    category: 'Embalagens & Envios',
    unit: 'un',
    suggested_minimum_quantity: 50,
    suggested_cost: 1.10,
    description: 'Envelope almofadado ideal para envio de cartas avulsas (singles) com segurança.',
    isEssential: true
  },
  {
    id: 'envios-envelope-bolha-m-20x25',
    name: 'Envelope com Bolha Kraft M (20x25cm)',
    category: 'Embalagens & Envios',
    unit: 'un',
    suggested_minimum_quantity: 30,
    suggested_cost: 1.65,
    description: 'Envelope acolchoado para envio de múltiplos toploaders ou decks leves.',
    isEssential: true
  },
  {
    id: 'envios-caixa-papelao-p-16x11x6',
    name: 'Caixa de Papelão para Envio P (16x11x6cm)',
    category: 'Embalagens & Envios',
    unit: 'un',
    suggested_minimum_quantity: 25,
    suggested_cost: 2.10,
    description: 'Caixa micro-ondulada reforçada para deckboxes, sleeves e pedidos maiores.',
    isEssential: true
  },
  {
    id: 'envios-caixa-papelao-m-20x16x10',
    name: 'Caixa de Papelão para Envio M (20x16x10cm)',
    category: 'Embalagens & Envios',
    unit: 'un',
    suggested_minimum_quantity: 20,
    suggested_cost: 3.20,
    description: 'Caixa reforçada para envio de Booster Boxes, Bundles e Tin Boxes.',
    isEssential: false
  },
  {
    id: 'envios-toploader-rigido-3x4-pct25',
    name: 'Toploader Rígido 3x4" para Envio de Singles (Pct com 25)',
    category: 'Embalagens & Envios',
    unit: 'pct',
    suggested_minimum_quantity: 10,
    suggested_cost: 18.00,
    description: 'Protetores rígidos plásticos essenciais para embalar cartas caras sem risco de dobra.',
    isEssential: true
  },
  {
    id: 'envios-cardsaver-semi-rigido-pct50',
    name: 'Card Saver / Protetor Semi-Rígido (Pct com 50)',
    category: 'Embalagens & Envios',
    unit: 'pct',
    suggested_minimum_quantity: 4,
    suggested_cost: 28.00,
    description: 'Protetor semi-rígido para proteção de cartas colecionáveis e graduação.',
    isEssential: false
  },
  {
    id: 'envios-team-bags-adesivadas-pct100',
    name: 'Team Bags / Saquinhos Adesivados para Toploader (Pct com 100)',
    category: 'Embalagens & Envios',
    unit: 'pct',
    suggested_minimum_quantity: 5,
    suggested_cost: 14.50,
    description: 'Saquinho selável para lacrar toploaders contra poeira e umidade no transporte.',
    isEssential: true
  },
  {
    id: 'envios-plastico-bolha-bobina-50cm',
    name: 'Bobina de Plástico Bolha (50cm x 50 metros)',
    category: 'Embalagens & Envios',
    unit: 'rolo',
    suggested_minimum_quantity: 2,
    suggested_cost: 35.00,
    description: 'Plástico bolha de alta densidade para forrar caixas e pacotes de e-commerce.',
    isEssential: true
  },
  {
    id: 'envios-fita-adesiva-larga-marrom',
    name: 'Fita Adesiva Marrom Larga (45mm x 50m)',
    category: 'Embalagens & Envios',
    unit: 'rolo',
    suggested_minimum_quantity: 6,
    suggested_cost: 4.80,
    description: 'Fita de alta aderência para fechamento seguro de caixas de papelão.',
    isEssential: true
  },
  {
    id: 'envios-fita-adesiva-transparente-larga',
    name: 'Fita Adesiva Transparente Larga (45mm x 50m)',
    category: 'Embalagens & Envios',
    unit: 'rolo',
    suggested_minimum_quantity: 6,
    suggested_cost: 4.80,
    description: 'Fita plástica transparente para prender declarações de conteúdo e etiquetas.',
    isEssential: true
  },
  {
    id: 'envios-etiqueta-adesiva-a4-declaracao',
    name: 'Folhas Adesivas A4 para Declaração de Conteúdo e Etiqueta (Pct 100)',
    category: 'Embalagens & Envios',
    unit: 'pct',
    suggested_minimum_quantity: 2,
    suggested_cost: 32.00,
    description: 'Folhas autoadesivas para impressão das etiquetas dos Correios/Melhor Envio.',
    isEssential: false
  },

  // ==========================================
  // 4. PREMIAÇÕES & TORNEIOS (8 itens)
  // ==========================================
  {
    id: 'torneios-sleeves-premios-standard-pct60',
    name: 'Sleeves Básicos Standard para Premiação (Pct com 60)',
    category: 'Premiações & Torneios',
    unit: 'pct',
    suggested_minimum_quantity: 15,
    suggested_cost: 9.00,
    description: 'Pacotes de sleeves simples para premiações de torneios semanais da loja.',
    isEssential: true
  },
  {
    id: 'torneios-deckbox-plastica-premiacao',
    name: 'Deckbox Plástica Básica com Fecho',
    category: 'Premiações & Torneios',
    unit: 'un',
    suggested_minimum_quantity: 12,
    suggested_cost: 8.50,
    description: 'Caixas organizadoras simples para premiações complementares de eventos.',
    isEssential: true
  },
  {
    id: 'torneios-dados-d20-spindown-kit10',
    name: 'Dados D20 Spindown / Marcadores de Vida (Kit com 10)',
    category: 'Premiações & Torneios',
    unit: 'pct',
    suggested_minimum_quantity: 3,
    suggested_cost: 25.00,
    description: 'Contadores de pontos de vida para eventos de Magic, Pokémon e Yu-Gi-Oh!.',
    isEssential: false
  },
  {
    id: 'torneios-cordao-cracha-juiz-organizador',
    name: 'Cordão com Porta Crachá para Juízes e Organizadores',
    category: 'Premiações & Torneios',
    unit: 'un',
    suggested_minimum_quantity: 6,
    suggested_cost: 4.50,
    description: 'Identificação oficial da comissão organizadora e juízes da loja.',
    isEssential: false
  },
  {
    id: 'torneios-bloco-sumula-match-slips',
    name: 'Bloco de Súmulas de Partida (Match Slips 50 jogos)',
    category: 'Premiações & Torneios',
    unit: 'un',
    suggested_minimum_quantity: 4,
    suggested_cost: 6.00,
    description: 'Tiras impressas de confirmação de resultado para juízes e mesa de emparceiramento.',
    isEssential: true
  },
  {
    id: 'torneios-playmat-emprestimo-mesas',
    name: 'Playmat Básico de Borracha para Empréstimo em Mesas',
    category: 'Premiações & Torneios',
    unit: 'un',
    suggested_minimum_quantity: 8,
    suggested_cost: 28.00,
    description: 'Tapetes de jogo emborrachados para preservação das cartas nas mesas da loja.',
    isEssential: false
  },
  {
    id: 'torneios-trofeu-campeao-personalizado',
    name: 'Troféu ou Medalha de Campeão da Temporada',
    category: 'Premiações & Torneios',
    unit: 'un',
    suggested_minimum_quantity: 2,
    suggested_cost: 45.00,
    description: 'Premiação especial para o campeão do Invitational ou torneio bimestral.',
    isEssential: false
  },
  {
    id: 'torneios-fichas-tokens-genericos-kit50',
    name: 'Fichas e Tokens Genéricos de Papel Cartão (Kit com 50)',
    category: 'Premiações & Torneios',
    unit: 'pct',
    suggested_minimum_quantity: 4,
    suggested_cost: 12.00,
    description: 'Marcadores de criatura, status e dano para partidas de jogos de cartas.',
    isEssential: false
  },

  // ==========================================
  // 5. ESCRITÓRIO & PAPELARIA (7 itens)
  // ==========================================
  {
    id: 'escritorio-folha-sulfite-a4-resma',
    name: 'Papel Sulfite A4 Branco 75g (Resma com 500 folhas)',
    category: 'Escritório & Papelaria',
    unit: 'pct',
    suggested_minimum_quantity: 2,
    suggested_cost: 28.00,
    description: 'Folhas para impressão de listas de decks, certificados, notas e comprovantes.',
    isEssential: true
  },
  {
    id: 'escritorio-caneta-esferografica-azul-cx50',
    name: 'Caneta Esferográfica Azul 1.0mm (Caixa com 50)',
    category: 'Escritório & Papelaria',
    unit: 'cx',
    suggested_minimum_quantity: 2,
    suggested_cost: 35.00,
    description: 'Canetas para empréstimo em torneios, preenchimento de súmulas e balcão.',
    isEssential: true
  },
  {
    id: 'escritorio-marcador-permanente-preto',
    name: 'Marcador Permanente Preto Ponta Dupla',
    category: 'Escritório & Papelaria',
    unit: 'un',
    suggested_minimum_quantity: 4,
    suggested_cost: 5.50,
    description: 'Marcador para endereçamento de caixas, envelopes e identificação de pastas.',
    isEssential: true
  },
  {
    id: 'escritorio-bobina-termica-80mm-pct10',
    name: 'Bobina Térmica Amarela/Branca 80mm para Cupom PDV (Pct c/ 10)',
    category: 'Escritório & Papelaria',
    unit: 'pct',
    suggested_minimum_quantity: 3,
    suggested_cost: 38.00,
    description: 'Bobinas de papel térmico para impressora não-fiscal do balcão e comprovantes.',
    isEssential: true
  },
  {
    id: 'escritorio-bloco-autoadesivo-postit',
    name: 'Bloco de Notas Autoadesivo Amarelo (Post-it)',
    category: 'Escritório & Papelaria',
    unit: 'un',
    suggested_minimum_quantity: 4,
    suggested_cost: 6.00,
    description: 'Anotações rápidas de encomendas de clientes e recados no balcão.',
    isEssential: false
  },
  {
    id: 'escritorio-grampeador-mesa-com-grampos',
    name: 'Grampeador de Mesa Médio + Caixa com 5000 Grampos 26/6',
    category: 'Escritório & Papelaria',
    unit: 'un',
    suggested_minimum_quantity: 1,
    suggested_cost: 24.00,
    description: 'Grampeador para fixação de declarações e relatórios de torneios.',
    isEssential: false
  },
  {
    id: 'escritorio-tesoura-estilete-profissional',
    name: 'Kit com Tesoura Multiuso Inox e Estilete Largo com Trava',
    category: 'Escritório & Papelaria',
    unit: 'un',
    suggested_minimum_quantity: 2,
    suggested_cost: 18.00,
    description: 'Ferramentas de corte essenciais para abertura de caixas e embalagem.',
    isEssential: true
  },

  // ==========================================
  // 6. MATERIAL DE CONSUMO & OPERACIONAL (4 itens)
  // ==========================================
  {
    id: 'consumo-sacos-plasticos-zip-pequenos-pct100',
    name: 'Saquinhos Ziplock Transparentes 8x12cm (Pct com 100)',
    category: 'Material de Consumo',
    unit: 'pct',
    suggested_minimum_quantity: 5,
    suggested_cost: 9.50,
    description: 'Saquinhos herméticos para separar dados, marcadores e lotes de cartas.',
    isEssential: true
  },
  {
    id: 'consumo-fita-crepe-24mm',
    name: 'Fita Crepe de Papel 24mm x 50m',
    category: 'Material de Consumo',
    unit: 'rolo',
    suggested_minimum_quantity: 4,
    suggested_cost: 5.20,
    description: 'Fita que não deixa resíduos, ideal para fixar papéis de emparceiramento e avisos.',
    isEssential: true
  },
  {
    id: 'consumo-elasticos-latex-borracha-pct100g',
    name: 'Elásticos de Borracha Látex Amarelo (Pacote 100g)',
    category: 'Material de Consumo',
    unit: 'pct',
    suggested_minimum_quantity: 2,
    suggested_cost: 7.00,
    description: 'Elásticos para agrupar envelopes de pedidos prontos para postagem.',
    isEssential: false
  },
  {
    id: 'consumo-flanela-limpeza-playmat',
    name: 'Flanela Macia de Limpeza de Superfície',
    category: 'Material de Consumo',
    unit: 'un',
    suggested_minimum_quantity: 4,
    suggested_cost: 4.00,
    description: 'Flanelas para conservação de vitrines de singles e acrílicos.',
    isEssential: false
  }
];

export const getPredefinedItemsByCategory = (category: string) => {
  if (category === 'all' || !category) return PREDEFINED_INVENTORY_ITEMS;
  return PREDEFINED_INVENTORY_ITEMS.filter(item => item.category === category);
};

export const getEssentialPredefinedItems = () => {
  return PREDEFINED_INVENTORY_ITEMS.filter(item => item.isEssential);
};
